export enum WebServicesAuthType {
  NO_AUTH = "NO_AUTH",
  BASIC = "BASIC",
  OAUTH2 = "OAUTH2"
}
